import type { actions } from '@luxuryescapes/contract-svc-ai-hotel';

import { json_headers, request } from './common';

export type GeneratePropertySummaryRequest =
  actions['generatePropertySummary']['requestBody']['content']['application/json'];

export type GeneratePropertySummaryResponse =
  actions['generatePropertySummary']['responses']['200']['content']['application/json'];

function basePath() {
  return window.configs.API_HOST + '/api/ai-hotel';
}

export function generatePropertySummary(
  payload: GeneratePropertySummaryRequest,
): Promise<GeneratePropertySummaryResponse> {
  return request(`${basePath()}/property-parity-summary`, {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify(payload),
  });
}
